module.exports = __webpack_public_path__ + "static/media/dsideLogo.438b0c76.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Basic/Footer/dsideLogo.svg
// module id = 723
// module chunks = 0